/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ImportGrdfConnectionTags$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected GRDF connection configuration
 */
  grdfUid: string;

/**
 * Indicates if the imports can create tags or only updates them.
 */
  allowCreate?: boolean;
      body?: Blob
}

export function importGrdfConnectionTags(http: HttpClient, rootUrl: string, params: ImportGrdfConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, importGrdfConnectionTags.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('grdfUid', params.grdfUid, {});
    rb.query('allowCreate', params.allowCreate, {});
    rb.body(params.body, 'application/vnd.ms-excel');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

importGrdfConnectionTags.PATH = '/stations/{uid}/grdf/configuration/{grdfUid}/import';
